<template>
  <div id="appContainer">
    <section>
      <div class="hero is-medium py-3">
        <div class="hero-body columns is-vcentered is-centered">
          <div class="column is-5-tablet is-12-mobile is-3-desktop pb-5">
            <figure id="m2Logo" class="image px-3">
              <img alt="The M2 Agency" src="./assets/M2-Agency-Logo.png" />
            </figure>
          </div>
          <div class="column is-7">
            <HelloWorld />
          </div>
        </div>
      </div>
    </section>

    <section class="columns is-centered py-2">
      <div class="column is-10-desktop is-7-widescreen is-12-tablet is-7-fullhd">
        <div class="columns is-vcentered">
          <div class="column box linkUpContainer">
            <div class="columns is-centered">
              <div class="column is-centered pt-6 has-text-centered">
                <figure id="linkUp" class="image">
                  <img alt="Link up" src="./assets/link-duo.png" />
                </figure>
              </div>
            </div>
            <div
              class="container px-4 py-4 subtitle is-size-4-desktop is-size-5-mobile"
            >Find us on IG or send us an email for any inquiries</div>
            <Connect title="Link up" />
          </div>
          <div class="column igContainer is-flex is-6-tablet">
            <IgPost />
          </div>
        </div>
      </div>
    </section>

    <section>
      <Clients />
    </section>

    <section class="pt-6 pb-5">
      <Connect title="Connect with us" />
    </section>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import Clients from "./components/Clients.vue";
import IgPost from "./components/IgPost.vue";
import Connect from "./components/Connect.vue";
export default {
  name: "App",
  components: {
    HelloWorld,
    Clients,
    IgPost,
    Connect,
  },
};
</script>

<style lang="scss">
#appContainer {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.footerBG a {
  padding: 5px;
}
#appContainer .box {
  background-color: rgba(255, 255, 255, 0.425);
}
figure#m2Logo {
  margin: 0 auto;
}
.linkUpContainer {
  max-width: 400px;
  margin: 0 auto;
}
figure#linkUp {
  max-width: 100px;
  max-height: 100px;
  display: inline-block;
}
.igContainer {
  justify-content: center;
}
</style>
